import { Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { PATHS } from '../router/routes';
import '../index.css';
import { useNavigate } from 'react-router-dom';
import Loader from './custom-components/loader/Loader';
import { GetMe } from '../graphql/queries/GetMe';
import { useLazyQuery } from '@apollo/client';
import { logout } from '../utils/auth';

const Dashboard = ({ children, title, ...props }) => {
    const router = useNavigate();
    const hasToken = localStorage.getItem('token') || sessionStorage.getItem('token');

    const [isHideLoader, setIsHideLoader] = useState(false);

    const illegalRoutes = [
        PATHS.SIGN_IN,
        PATHS.SIGN_UP,
        PATHS.FORGOT_PASSWORD,
        PATHS.CHANGE_PASSWORD,
        PATHS.VERIFICATION,
    ].some((route) => title?.includes(route));

    const redirect = (route) => {
        setTimeout(() => {
            router(route);
            setIsHideLoader(true);
        }, 500);
    };

    const [fetchMe] = useLazyQuery(GetMe, {
        onCompleted(data) {
            if (data?.getMe?.__typename === 'UserModelType') {
                if (illegalRoutes) {
                    const isAgentCreated = data?.getMe?.isAgentCreated;

                    const isFinishedStepper = data?.getMe?.isFinishedStepper;

                    const isFinishedRegistration = data?.getMe?.company && data?.getMe?.phoneNumber;

                    const isSubscribed = data?.getMe?.isSubscribed;

                    if (isAgentCreated) {
                        redirect(PATHS.MY_AGENT);
                    } else {
                        if (!isFinishedStepper) {
                            if (!isFinishedRegistration) {
                                redirect(PATHS.TELL_US_MORE);
                            } else {
                                redirect(PATHS.BUSINESS_INFO);
                            }
                        } else if (!isSubscribed) {
                            redirect(PATHS.SUBSCRIPTION_PLAN);
                        } else {
                            redirect(PATHS.PHONE_PICK);
                        }
                    }
                }
            } else {
                redirect(PATHS.SIGN_IN);
                logout();
            }
        },
    });

    // const isShowHeader = useMemo(() => {
    //     if (title === PATHS.SIGN_IN || title === PATHS.SIGN_UP || title === PATHS.FORGOT_PASSWORD) {
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }, [title]);

    useEffect(() => {
        if (hasToken) {
            fetchMe();
        }
    }, [hasToken, title, fetchMe]);

    if (illegalRoutes) {
        if (hasToken && !isHideLoader) {
            return <Loader />;
        }
    }

    return (
        <Box {...props}>
            {/* {isShowHeader && <ZaraHeader title={title} />} */}
            {children}
        </Box>
    );
};

export default Dashboard;
